'use client';

import { c as _c } from "react/compiler-runtime";
import { setFileUploader } from '@algoacademy/design-system/web/actions/Attachments/uploadFiles';
import { useEffect } from 'react';
import { useTRPCClient } from '@/app/_trpc/config';
export function FileUploaderProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const trpcClient = useTRPCClient();
  let t1;
  let t2;
  if ($[0] !== trpcClient) {
    t1 = () => {
      setFileUploader(async input => {
        const result = await trpcClient.content.createPresignedUpload.mutate(input);
        return {
          uploadUrl: result.uploadUrl,
          publicUrl: result.publicUrl,
          key: result.key
        };
      });
    };
    t2 = [trpcClient];
    $[0] = trpcClient;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return children;
}